import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { IFermenterVM } from 'app/models/fermenter';

/** Pressure PET conical fermenter (FermZilla / Fermentasaurus style). */
@Component({
  selector: 'app-fermenter-pressure-svg',
  templateUrl: './fermenter-pressure-svg.component.svg',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  styles: [':host{display:block;width:100%;height:100%} svg{display:block;width:100%;height:100%}'],
})
export class FermenterPressureSvgComponent implements OnChanges {
  @Input() item!: IFermenterVM;
  private readonly topY = 66;
  private readonly bottomY = 206;
  height = 0;
  y = this.bottomY;
  ngOnChanges(): void {
    if (!this.item) return;
    const size = this.item.size ?? 0;
    const amount = this.item.amount ?? 0;
    const tot = this.bottomY - this.topY;
    const f = size <= 0 || amount <= 0 ? 0 : Math.min(amount / size, 1);
    this.height = tot * f;
    this.y = this.bottomY - this.height;
  }
}
